import { emptyGrnLine, type DraftGrnLine } from './GrnLineEditor';
import type { POItemDetail } from '../types';

/**
 * Seeds a "Mark Received" draft from a PO's ordered lines. quantity_received
 * defaults to quantity_ordered and unit_cost to expected_unit_cost — both
 * stay plain editable inputs, since the vendor may have shipped a different
 * quantity/price than what was ordered (single receive-and-close: the PO
 * always flips to 'received' on submit regardless of any variance). Batch,
 * expiry, MRP, GST, schedule and strip detail have no PO-side source and
 * stay blank, exactly like a hand-typed GRN line.
 */
export function linesFromPoItems(items: POItemDetail[], gstPercentageOptions: number[]): DraftGrnLine[] {
  return items.map((item) => ({
    ...emptyGrnLine(gstPercentageOptions),
    medicine_id: item.generic_name ? item.medicine_id : null,
    resolved_label: item.generic_name
      ? `${item.generic_name}${item.brand_name ? ` — ${item.brand_name}` : ''}${item.strength ? ` ${item.strength}` : ''}`
      : '',
    source_hint: item.medicine_name,
    dosage_form: item.dosage_form || 'Tablet',
    quantity_received: String(item.quantity_ordered),
    unit_cost: item.expected_unit_cost != null ? String(item.expected_unit_cost) : '',
  }));
}
